module.exports = __webpack_public_path__ + "static/img/6674_phase_function_Paper_Points.9928c24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6674_phase_function_Paper_Points.png
// module id = ovzg
// module chunks = 0